import React, { useEffect } from 'react';
import { Box } from '@material-ui/core';
import { discoveryAppUsers } from '../columns';
import BuzzPagination from '../../../components/BuzzPagination/BuzzPagination';
import { useDispatch, useSelector } from 'react-redux';
import { getUserDiscoveryTableAsync } from '../ManagementStore/ManagementStoreSlice';
import BuzzTable from '../../../components/BuzzTable/BuzzTable';
import { useState } from 'react';
import BuzzInput from '../../../components/BuzzInput/BuzzInput';

function DiscoveryAppUser() {
  const [page, setPage] = useState(1);
  const [city, setCity] = useState('');
  const dispatch = useDispatch();
  const PER_PAGE = 10;

  const { totalDiscoveryAppUser } = useSelector(
    ({ managementStoreReducer }) => {
      return {
        totalDiscoveryAppUser: managementStoreReducer.discoveryUserTable
          ? managementStoreReducer.discoveryUserTable
          : null,
      };
    }
  );

  useEffect(() => {
    dispatch(
      getUserDiscoveryTableAsync({
        params: {
          limit: PER_PAGE,
          page: 1,
        },
      })
    );
  }, []);

  const handlePageChange = (val) => {
    if (val !== page) {
      setPage(val);
      dispatch(
        getUserDiscoveryTableAsync({
          params: {
            limit: PER_PAGE,
            page: val,
            latestFirst: true,
          },
        })
      );
    }
  };

  const handleSearchCity = () => {
    if (city !== '') {
      dispatch(
        getUserDiscoveryTableAsync({
          params: {
            limit: 10,
            page: 1,
            city: city,
            latestFirst: true,
          },
        })
      );
    } else {
      dispatch(
        getUserDiscoveryTableAsync({
          params: {
            limit: 10,
            page: 1,
            latestFirst: true,
          },
        })
      );
    }
  };
  return (
    <>
      <Box mb={4} width={350}>
        <BuzzInput
          fullWidth={true}
          placeholder={'Search User By City'}
          search
          value={city}
          onChange={(e) => setCity(e.target.value)}
          onSubmitEditing={handleSearchCity}
          size="small"
          label="Seach User By City"
        />
      </Box>
      <BuzzTable columns={discoveryAppUsers} data={totalDiscoveryAppUser} />
      <Box display="flex" justifyContent="center">
        <BuzzPagination
          onClick={handlePageChange}
          total={10}
          pageNo={1}
          defaultPage={1}
          perPage={PER_PAGE}
        />
      </Box>
    </>
  );
}

export default DiscoveryAppUser;
